import React from 'react';

import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';

import { collectImageComponentParams } from '../shared/collector';

import AiVectorGenerator from './AiVectorGenerator';
import { AiVectorGeneratorStrapiComponent } from './types';

export class AiVectorGenerationAppComponentBuilder extends ComponentBuilder {
  public key = 'micro-apps.vector-generator' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: AiVectorGeneratorStrapiComponent;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            background: true,
          },
        },
      },
    });

    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }

    return {
      background: collectImageComponentParams(componentData.background),
      title: componentData.title,
      subline: componentData.subline,
    };
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs) {
      return <AiVectorGenerator {...inputs} />;
    } else {
      return null;
    }
  }
}
